export const EVENT_SUBSCRIBE_MODULE_OFFER_CODES =
  'event-ind-pg-sub-module-2026-299,event-ind-pg-sub-module-2026-749';

export enum EventAvailability {
  AllAccessOnly = 'all access only',
  AllAccessAndAnnual = 'all access and annual',
  AllAccessAndAnnualExcludeYp = 'all access and annual, exclude yp',
  AllSubscribers = 'all subscribers',
  InviteOnly = 'invite only',
  NotYetOpen = 'not yet open',
  OpenToAll = 'open to all',
  RegistrationHasPassed = 'registration has passed',
  SoldOut = 'sold out',
  SoldOutToSubsOpenToLeads = 'sold out to subs, open to leads',
}
